/**
 * Language options for language dropdown in Account Settings modal
 * @author Akash Salvi <akash.salvi@helpshift.com>
 * @created April 15, 2025
 * @module constants/modals/i18nLanguageOptions
 */

const DEFAULT_I18N_LANG = "en";

const I18N_LANGUAGE_OPTIONS = [
  {
    label: "English (US)",
    value: "en"
  },
  {
    label: "日本語",
    value: "ja"
  }
];

if (window?.HS && !window?.HS?.loggers?.is_prod_env) {
  I18N_LANGUAGE_OPTIONS.push({
    label: "Ƥśēũďō",
    value: "pseudo"
  });
}

export {DEFAULT_I18N_LANG, I18N_LANGUAGE_OPTIONS};
